import React, {useState, useEffect} from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import RichTextEditor from "../../components/RichTextEditor";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import {useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import fetcher from "../../fetcher";
import {useFetchEmailContent} from "../../hooks/useFetchEmailData";
import {toast} from "react-toastify";

import './Email.scss'
import AttachmentIcon from '@mui/icons-material/Attachment';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ClearIcon from '@mui/icons-material/Clear';
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";
import useDidMountEffect from "../../hooks/useDidMountEffect";

export const BaseEmailPage = (props) => {
    const {
        getContent,

        to,
        from,
        subject,

        isOpen,
        setIsOpen,
    } = props

    const [emailState, setEmailState] = useState({
        to: to,
        cc: from,
        from: from,
        subject: `RE: ${subject}`
    })

    const {content, attachments} = useFetchEmailContent(getContent)

    const [selectedFiles, setSelectedFiles] = useState(attachments);

    const editor = useEditor({
        extensions: [
            StarterKit,
        ],
        content,
    }, [content])

    useDidMountEffect(function setAttachmentsAfterLoad(){
        setSelectedFiles(attachments)
    }, [attachments])

    useEffect(function revokeObjectURLOnUnmount(){
        return () => {
            for (let i = 0; i < selectedFiles.length; i++) {
                const file = selectedFiles[i]
                URL.revokeObjectURL(file)
            }
        }
    },[])

    const removeAttachment = (file, index) => {
        let newFiles = structuredClone(selectedFiles)
        newFiles.splice(index, 1)
        setSelectedFiles(newFiles)
    }

    const handleFileChange = (event) => {
        setSelectedFiles([...selectedFiles, ...Array.from(event.target.files)]);
    };

    const sendEmail = async () => {
        const formData = new FormData();
        selectedFiles.forEach((file) => {
            formData.append('attachments', file);
        });

        const emailData = {
            to: emailState.to,
            _from: emailState.from,
            html: editor.getHTML(),
            subject: subject,
            cc: emailState.cc,
        }
        formData.append("email_data", JSON.stringify(emailData))

        return fetcher.createEmail(formData).then(()=> {
                toast.success("Email sent.")
        })
    }

    if (!editor) return null;
    return (
            <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="left"
                id={'BaseEmailPage'}
            >
                <Typography
                    gutterBottom
                    variant="h5"
                    component="span"
                    style={{
                        fontWeight: '500',
                        fontSize: '20px',
                    }}
                >
                    New message
                </Typography>

                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent={"flex-start"}
                    className={"email-message__row"}
                >
                    <label>To: </label>
                    <input
                        className="email"
                        type="text"
                        value={emailState.to}
                        onChange={(e) => setEmailState({...emailState, to: e.target.value})}
                    />
                </Stack>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent={"flex-start"}
                    className={"email-message__row"}
                >
                    <label>Cc: </label>
                    <input
                        className="email"
                        type="text"
                        value={emailState.cc}
                        onChange={(e) => setEmailState({...emailState, cc: e.target.value})}
                    />
                </Stack>
                <Divider className={'divider'} sx={{ marginBottom: '5px'}}/>

                <Stack
                    direction="row"
                    alignItems="start"
                    justifyContent={"flex-start"}
                    // className={"email-message__row"}
                >
                    <Typography
                        gutterBottom
                        component="span"
                        style={{
                            fontWeight: '500',
                            fontSize: '14px',
                            width: '100%',
                        }}
                    >
                        <input
                            className=""
                            type="text"
                            value={emailState.subject}
                            onChange={(e) => setEmailState({...emailState, subject: e.target.value})}
                    />
                    </Typography>
                </Stack>

                <Divider className={'divider'} sx={{ marginBottom: '5px', borderColor: 'rgba(0, 0, 0, 0.12)'}}/>

                {
                    !content &&
                    <Skeleton
                        variant="rectangular"
                        width={545}
                        height={545}
                        style={{ borderRadius: '4px '}}
                    />
                }
                {
                    content &&
                    <RichTextEditor content={content} editor={editor}/>
                }



                <Divider className={'divider'} sx={{ marginBottom: '10px'}}/>

                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent={"space-between"}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent={"flex-start"}
                    >
                        <input
                            id="email-file-uploader"
                            type="file"
                            name="filefield"
                            multiple
                            hidden
                            onChange={handleFileChange}
                        />
                        <Tooltip title={'Attach Files'} arrow placement={'top'}>
                            <Button
                                onClick={() => {
                                    document.getElementById('email-file-uploader').click();
                                }}
                                style={{
                                    alignSelf: 'end'
                                }}
                            >
                                <AttachFileIcon/>
                            </Button>
                        </Tooltip>

                        {selectedFiles.length > 0 && (
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent={"start"}
                                flexWrap={"wrap"}
                                className={"attachment-container"}
                            >
                                {selectedFiles.map((file, index) => (
                                    <a
                                        key={index}
                                        className={"attachment"}
                                        href={URL.createObjectURL(file)}
                                        target={"_blank"}
                                    >
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent={"start"}
                                        >
                                            <AttachmentIcon/>
                                            <span>{file.name}</span>

                                            <ClearIcon
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    e.preventDefault()
                                                    removeAttachment(file, index)
                                                }}
                                                className={'attachment-remove'}
                                            />
                                        </Stack>
                                    </a>
                                ))}
                            </Stack>
                        )}
                    </Stack>
                    <Tooltip title={'Send Email'} arrow placement={'top'}>
                        <Button
                            disabled={Boolean(!emailState.to)}
                            style={{
                                alignSelf: 'end'
                            }}
                            onClick={() => {
                                sendEmail()
                                setIsOpen(false)
                            }}
                        >
                            <SendIcon/>
                        </Button>
                    </Tooltip>
                </Stack>

            </Stack>
    )
}